import { render, staticRenderFns } from "./InventoryCustomerViewInformation.vue?vue&type=template&id=1bf8fd42&"
import script from "./InventoryCustomerViewInformation.vue?vue&type=script&lang=js&"
export * from "./InventoryCustomerViewInformation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports